export default "__VITE_ASSET__48928821__"